import React from 'react';
import { Typography, Container } from '@mui/material';

const TermsOfService = () => {
  React.useEffect(() => {
    document.title = 'My Store - Terms of Service';
  }, []);

  return (
    <Container maxWidth="md">
      <Typography variant="h4" component="h1" gutterBottom>
        Terms of Service
      </Typography>
      <Typography variant="body1" paragraph>
        These are the Terms of Service for our online store. By using our website, you agree to these terms.
      </Typography>
      {/* Add more content here */}
    </Container>
  );
};

export default TermsOfService;